var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandardShippingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.303,
    height: 10.287,
    viewBox: "0 0 10.303 10.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "standard_shipping_icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M127.083,136.5h7.437l.014,0,.011,0,.011,0,.011,0,.011,0,.01,0,.011-.005.01-.005.01-.006.01-.007.009-.007.011-.01.006-.006,2.414-2.373h0l.012-.013,0-.005c0-.005.009-.012.014-.018l.008-.014,0-.008.005-.012,0-.009,0-.011,0-.011,0-.01,0-.013a.193.193,0,0,0,0-.023v-.006c0-.006,0-.012,0-.018h0v-7.429a.242.242,0,0,0-.242-.242h-7.427l-.011,0-.013,0-.011,0-.012,0-.011,0-.011,0-.01,0-.011.005-.01.006-.01.006-.01.007-.009.007-.011.009-.006.006-2.414,2.372h0l-.011.013,0,.005-.013.017-.009.014,0,.008-.006.012,0,.01,0,.01,0,.012,0,.01,0,.013c0,.008,0,.015,0,.023v.007c0,.006,0,.012,0,.018h0v7.429A.242.242,0,0,0,127.083,136.5Zm7.162-.484h-6.919v-6.945h2.3v3.74l.639-.443.49.443.481-.462.749.462v-3.74h2.262Zm.484-7.087,1.93-1.954v6.809l-1.93,1.9Zm-.344-.342H132.27l1.851-1.888h2.129ZM129.6,126.7h2.146l-1.917,1.888h-2.151Z",
    transform: "translate(-126.841 -126.215)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardShippingIcon);
export default __webpack_public_path__ + "static/media/standard_shipping_icon.9d060c93ebd4593536d008f9d5e36761.svg";
export { ForwardRef as ReactComponent };